<template>
  <div class="navbar-menu">
    <toggle-button
      :label="username"
      @click="toggle"
    />

    <overlay
      :isVisible="isVisible"
      @click="handleOverlayClick"
    >
      <nav
        class="navbar-menu-nav"
        :class="{ 'is-visible': isVisible }"
      >
        <close-button :handleClick="hide" />
        <slot />
      </nav>
    </overlay>
  </div>
</template>

<script>
import { CloseButton, Overlay, ToggleButton } from '@/javascripts/components/ui'

export default {
  name: 'NavbarMenu',
  data() {
    return {
      isVisible: false
    }
  },
  props: {
    username: {
      type: String,
      required: true
    }
  },
  components: {
    CloseButton,
    Overlay,
    ToggleButton
  },
  methods: {
    hide() {
      if (!this.isVisible) return

      this.isVisible = false
    },
    toggle() {
      this.isVisible = !this.isVisible
    },
    handleOverlayClick(e) {
      if (e.currentTarget !== e.target) return

      this.hide()
    },
    handleKeydown(e) {
      const char = e.which || e.keyCode

      if (char !== 27) return

      this.hide()
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown)
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../stylesheets/color-theme';

  .navbar-menu {
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 1rem;

    &-nav {
      position: fixed;
      top: 0;
      right: 0;
      width: 22.5rem;
      max-width: 80%;
      height: 100%;
      background-color: $white;
      z-index: 1;
      transform: translateX(100%);
      transition: transform .3s;

      &.is-visible {
        transform: translateX(0);
        transition: transform .3s;
      }
    }
  }
</style>
